// extracted by mini-css-extract-plugin
module.exports = {"title":"propertiesViewHeader_title__1L1Tu","textHidden":"propertiesViewHeader_textHidden__3v1sz","titleSection":"propertiesViewHeader_titleSection__2k4R6","openArrow":"propertiesViewHeader_openArrow__2Z7cS"};
    if(module.hot) {
      // 1745223399524
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  